import { render, staticRenderFns } from "./SourceTypeFilter.vue?vue&type=template&id=53a52140"
import script from "./SourceTypeFilter.vue?vue&type=script&lang=js"
export * from "./SourceTypeFilter.vue?vue&type=script&lang=js"
import style0 from "./SourceTypeFilter.vue?vue&type=style&index=0&id=53a52140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports